import React from 'react';

const EBillIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_658_35651)">
      <path
        d="M11.5 6.5C11.5 8.0913 12.1321 9.61742 13.2574 10.7426C14.3826 11.8679 15.9087 12.5 17.5 12.5C19.0913 12.5 20.6174 11.8679 21.7426 10.7426C22.8679 9.61742 23.5 8.0913 23.5 6.5C23.5 4.9087 22.8679 3.38258 21.7426 2.25736C20.6174 1.13214 19.0913 0.5 17.5 0.5C15.9087 0.5 14.3826 1.13214 13.2574 2.25736C12.1321 3.38258 11.5 4.9087 11.5 6.5V6.5Z"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.174 4.755L17.269 8.629C17.2044 8.71491 17.1221 8.78595 17.0277 8.83733C16.9333 8.8887 16.829 8.91921 16.7217 8.9268C16.6145 8.93438 16.5069 8.91886 16.4062 8.88129C16.3055 8.84371 16.214 8.78496 16.138 8.709L14.638 7.209"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.5 16.5H21.5"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 13.5V18.5C21.5 18.7652 21.3946 19.0196 21.2071 19.2071C21.0196 19.3946 20.7652 19.5 20.5 19.5H1.5C1.23478 19.5 0.98043 19.3946 0.792893 19.2071C0.605357 19.0196 0.5 18.7652 0.5 18.5V5.5C0.5 5.23478 0.605357 4.98043 0.792893 4.79289C0.98043 4.60536 1.23478 4.5 1.5 4.5H9.5"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 23.5C8.90582 22.3562 9.43041 20.9573 9.5 19.5"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 23.5C13.0942 22.3562 12.5696 20.9573 12.5 19.5"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 23.5H15.5"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_658_35651">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { EBillIcon };
